/**
 * @author Vaibhav <vaibhav.mane@314ecorp.com>
 * @description hook to add or update saved search
 */

import log from 'loglevel';
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import EventBus, { Events, Messages } from '@dexit/common/utils/EventBus';
import api from 'client/index';
import { QUERY_SAVED_SEARCH } from 'hooks/useSavedSearch';
import { ResponseModel, SavedSearchRequestModel } from '@dexit/common/openapi';

const useCreateSavedSearch = (): UseMutationResult<ResponseModel, unknown, SavedSearchRequestModel, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (payload) => {
			const { data } = await api.SavedSearchApi.createSavedSearch(payload);
			return data;
		},
		onError: () => {
			EventBus.publish(Events.M_Error, Messages.Error);
		},
		onSuccess: (data) => {
			queryClient.invalidateQueries([QUERY_SAVED_SEARCH]).catch((err) => log.error(err));
			EventBus.publish(Events.M_Success, data.message);
		},
	});
};

export default useCreateSavedSearch;
